const React = require('react');
const PropTypes = require('prop-types');
const { isMobile } = require('utilities/browserUtils');
const RiskProfitTableDesktop = require('./RiskProfitTableDesktop');
const RiskProfitTableMobile = require('./RiskProfitTableMobile');

const RiskProfitTable = ({ className, data, onRowActioned, selected }) =>
    isMobile() ? (
        <RiskProfitTableMobile
            className={className}
            data={data}
            onRowClick={onRowActioned}
            selected={selected}
        />
    ) : (
        <RiskProfitTableDesktop
            className={className}
            data={data}
            onMouseEnterRow={onRowActioned}
        />
    );

RiskProfitTable.propTypes = {
    className: PropTypes.string,
    data: PropTypes.object.isRequired,
    onRowActioned: PropTypes.func,
    selected: PropTypes.any,
};

module.exports = RiskProfitTable;
